<template>
  <div>   
    <div v-if="isStudent" class="cs-videoButton-container">
      <el-button
        v-if="cancelEnable"
        :disabled="btnDisabled"
        type="primary"
        size="mini"
        @click="onCancel"
      >取消预约</el-button>
      <el-button
        v-if="viewEnable"
        :disabled="btnDisabled"
        type="primary"
        size="mini"
        @click="onView"
      >开始观看</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.el-dropdown {
  .el-dropdown-link {
    img {
      height: 1rem;
      padding-left: 1rem;
    }
  }
}
.cs-appointment-green {
  color: #009145;
}
.cs-appointment-red {
  color: #e1272d;
}
.cs-videoButton-container{
  .el-button{
    display: block;
    margin-left: 0;
    margin-top: 3px;
  }
}
</style>

<script>
import { cancelVideoAppointment } from "../../../service/videoAppointment.service";
import { isInRole } from "../../../config/mUtils";
import global_ from "@/core/global";

export default {
  props: {
    data: {},
    columnData: {},
    status: {}
  },
  data() {
    return {
      statusValue: 0,
      statusText: "",
      btnDisabled: false,
      cancelEnable: false,
      continueEnable: false,
      payEnable: false,
      viewEnable: false,
      isStudent: isInRole(global_.roleType.student.name),
      iconSrc: require("../../../assets/icon-dropdown.png")
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.statusValue = this.data.Status;
        this.statusText = this.data.StatusString;
        this.cancelEnable = this.data.CancelEnable;
        this.continueEnable = this.data.ContinueEnable;
        this.payEnable = this.data.PayEnable;
        this.viewEnable = this.data.ViewEnable;

        //this.viewEnable = true;
      }
    },
    getStatusClass() {
      let cls = "";
      if (!!this.data) {
        if (
          this.data.Status == 1 ||
          this.data.Status == 2 ||
          this.data.Status == 4
        ) {
          cls = "cs-appointment-green";
        } else {
          cls = "cs-appointment-red";
        }
      }
      if (!this.isStudent) {
        cls += " el-dropdown-link";
      }

      return cls;
    },
    onCancel() {
      let message = "是否要取消预约?";

      if (this.data.BalanceCost > 0 || this.data.BonusPointPrice > 0) {
        message += " 取消预约后，只会退还一半费用。";
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.btnDisabled = true;

          cancelVideoAppointment(this.data.Id)
            .then(result => {
              if (!!result && result.success) {
                //this.$emit("reload");
                let data = {
                  name: "reload"                 
                };
                this.$emit("customEvent", data);
              } else {
                this.$message.error(result.message);
              }

              this.btnDisabled = false;
            })
            .catch(err => {
              this.btnDisabled = false;
            });
        })
        .catch(() => {});
    },
    onContinue() {
      let data = {
        name: "continue",
        id: this.data.Id
      };
      this.$emit("customEvent", data);
    },
    onPay() {
      let data = {
        name: "pay",
        id: this.data.Id
      };
      this.$emit("customEvent", data);
    },
    onView() {
      let data = {
        name: "view",
        row: this.data,
        id: this.data.Id
      };
      this.$emit("customEvent", data);
    },
    handleCommand(command) {
      this.changeStatus(command);
    },
    changeStatus(status) {
      let data = {
        name: "changeStatus",
        id: this.data.Id,
        status: status
      };
      this.$emit("customEvent", data);
    }
  },
  watch: {
    data: function() {
      this.init();
    },
    "data.ViewEnable":function(){
      this.viewEnable = this.data.ViewEnable;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/videoButtonCell.vue